import type * as Types from 'connect-graphql/generated';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerRapsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LearnerRapsQuery = { __typename?: 'Query', assignedRaps: Array<{ __typename?: 'RegisteredApprenticeshipProgram', id: string }> };


export const LearnerRapsDocument = gql`
    query LearnerRaps {
  assignedRaps {
    id
  }
}
    `;

export function useLearnerRapsQuery(options?: Omit<Urql.UseQueryArgs<LearnerRapsQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnerRapsQuery, LearnerRapsQueryVariables>({ query: LearnerRapsDocument, ...options });
};